import { colors } from 'fitify-ui'
import { ButtonStyles } from 'fitify-ui-landing/src/components/Button/Button.Styles'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledFeature = styled.div<{ $isEven: boolean }>`
  display: flex;
  align-items: center;

  &:not(:first-child) {
    margin-top: 80px;
  }

  ${(props) =>
    props.$isEven
      ? css`
          flex-direction: row-reverse;
        `
      : undefined}

  ${phone(css`
    &:not(:first-child) {
      margin-top: 40px;
    }

    flex-direction: column-reverse;
  `)};
`

export const StyledFeatureItem = styled.div<{ $isEven: boolean }>`
  width: 100%;

  > ${ButtonStyles} {
    width: fit-content;
    background: ${colors.RoyalBlue500};
    ${(props) =>
      props.$isEven
        ? css`
            margin-left: 128px;
            ${phone(css`
              margin-left: initial;
            `)};
          `
        : undefined}
    &:not(:first-child) {
      margin-top: 36px;

      ${phone(css`
        margin-top: 16px;
      `)}
    }
  }

  > ${TextStyles} {
    ${phone(css`
      max-width: initial;
    `)};

    ${(props) =>
      props.$isEven
        ? css`
            margin-left: 128px;
            ${phone(css`
              margin-left: initial;
            `)};
          `
        : css`
            margin-right: 128px;
            ${phone(css`
              margin-right: initial;
            `)};
          `}
    &:not(:first-child) {
      margin-top: 16px;
    }
    &:first-child {
      ${phone(css`
        margin-top: 20px;
      `)}
    }
  }
`

export const StyledFeatureItemImage = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;

  img {
    border-radius: 24px;
  }
`
